import { render, staticRenderFns } from "./Hero.vue?vue&type=template&id=9001a764&scoped=true"
import script from "./Hero.vue?vue&type=script&lang=ts"
export * from "./Hero.vue?vue&type=script&lang=ts"
import style0 from "./Hero.vue?vue&type=style&index=0&id=9001a764&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9001a764",
  null
  
)

export default component.exports